export default __webpack_public_path__ + "assets/images/Payment_03.6abe2a.png";